type SortOrder = "asc" | "desc";

export interface SortState<T extends Record<string, any>> {
  sortKey: keyof T;
  sortOrder: SortOrder;
}

export const createSortingService = <T extends Record<string, any>>() => {
  const sortData = (data: T[], sortState: SortState<T>): T[] => {
    return [...data].sort((a, b) => {
      const aVal = a[sortState.sortKey];
      const bVal = b[sortState.sortKey];

      let comp = 0;

      if (typeof aVal === "number" && typeof bVal === "number") {
        comp = aVal - bVal;
      } else {
        const valueA = String(aVal).toLowerCase();
        const valueB = String(bVal).toLowerCase();
        if (valueA < valueB) comp = -1;
        else if (valueA > valueB) comp = 1;
        else comp = 0;
      }

      return sortState.sortOrder === "asc" ? comp : -comp;
    });
  };

  const createSortHandler = (
    currentSort: SortState<T>,
    setSort: React.Dispatch<React.SetStateAction<SortState<T>>>
  ) => (key: keyof T) => {
    if (currentSort.sortKey === key) {
      setSort({
        sortKey: key,
        sortOrder: currentSort.sortOrder === "asc" ? "desc" : "asc"
      });
    } else {
      setSort({ sortKey: key, sortOrder: "asc" });
    }
  };

  const getSortIcon = (currentSort: SortState<T>, key: keyof T): string => {
    return currentSort.sortKey === key
      ? currentSort.sortOrder === "asc"
        ? "↑"
        : "↓"
      : "";
  };

  return {
    sortData,
    createSortHandler,
    getSortIcon
  };
};
